import SalesPageStoreForm from './SalesPageStoreForm';

export default SalesPageStoreForm;
